import { render, staticRenderFns } from "./BottomButtons.vue?vue&type=template&id=42e4d660&scoped=true&"
import script from "./BottomButtons.vue?vue&type=script&lang=js&"
export * from "./BottomButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42e4d660",
  null
  
)

export default component.exports